import { Injectable } from '@angular/core';
import { Models } from '@ibexfusion/models';

import { RestfulService } from '../rest/restful';
import { RestProvider, RestService } from '../rest/rest.service';

@Injectable()
export class ImageAssetsService extends RestfulService<Models.ImageAsset> {

  constructor(private restService: RestService) {
    super(Models.ImageAsset);
    super.init();
  }

  public createProvider(): RestProvider {
    return this.restService.createProvider('image-assets');
  }

}
